import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { first, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { KycComponent } from '../kyc/kyc.component';
import { OtpverificationComponent } from '../otpverification/otpverification.component';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CommonService } from '../../../_common/_service/user.service';
import { formattedError } from '@angular/compiler';


@Component({
  selector: 'app-merchantdoc',
  templateUrl: './merchantdoc.component.html',
  styleUrls: ['./merchantdoc.component.scss']


})

export class MerchantdocDialogComponent implements OnInit {
  currentDate = new Date();
  submitted = false;
  myFiles: string[] = [];
  myFilesimgMemorandum: string[] = [];
  myFilesimgCertificate: string[] = [];

  imgURLlogo: any = '';
  imgURLaddrsFile: any = '';
  imgURLIdback: any = '';
  imgURLIdfnt: any = '';

  logoImage: any;


  isLoggedIn = false;
  msg1: any;
  msg2: any;
  msg3: any;
  msg4: any;
  btn: any;
  currentUser: any;

  imgURL: any = '';
  imageData: any;

  addrsDocList: any[] = [];
  addrsDocImageDataList: any[] = [];

  shareholdersIDList: any[] = [];
  shareholdersIDImageDataList: any[] = [];

  shareholdersPicturesList: any[] = [];
  shareholdersPicturesDataList: any[] = [];
  imgURLshareholdersID: any;
  imgURLshareholdersPicture: any;
  KycType: any;

  imgMemorandum: any;
  logoMemorandum: any;
  msgMemorandum: any;

  imgCertificate: any;
  logoCertificate: any;
  msgCertificate: any;

  loadingspinner: boolean = false;
  imgMemorandumurl: any;
  imgCertificateurl: any;

  imgMemorandumname: any;
  imgCertificatename: any;

  constructor(private readonly adapter: DateAdapter<Date>, public datepipe: DatePipe, private fb: FormBuilder, private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, private _service: AuthenticationService, public dialogRef: MatDialogRef<MerchantdocDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private withouttokenService: AuthenticationService, private _service1: CommonService) {
    this.adapter.setLocale('en-GB'); //dd/MM/yyyy
    this.adapter.format(this.currentDate, "MM/YYYY");

  }

  ngOnInit() {

    this.imgURLlogo = '../../../../assets/Images/imgId.png';
    this.currentUser = this.tokenStorageService.getUser();
    this.btn = this.data;
    if (this.btn != 0) {
      this.getKYCUserDetails();
    }
  }

  upload() {
    this.submitted = true;
    if (this.btn == 0 || this.btn == 4) {
      if (!this.logoImage && !this.imgURLaddrsFile && !this.imgURLshareholdersID && !this.imgURLshareholdersPicture && !this.logoCertificate && !this.logoMemorandum) {

        this.msg1 = "No File Selected";
        this.msg2 = "No File Selected";
        this.msg3 = "No File Selected";
        this.msg4 = "No File Selected";
        this.msgMemorandum = "No File Selected";
        this.msgCertificate = "No File Selected";
        return;
      }

      if (!this.logoImage) {
        this.msg1 = "No File Selected";
        return;
      }
      if (!this.imgURLaddrsFile) {
        this.msg2 = "No File Selected";
        return;
      }
      if (!this.imgURLshareholdersID) {
        this.msg3 = "No File Selected";
        return;
      }
      if (!this.imgURLshareholdersPicture) {
        this.msg4 = "No File Selected";
        return;
      }
      if (!this.logoMemorandum) {
        this.msgMemorandum = "No File Selected";
        return;
      }
      if (!this.logoCertificate) {
        this.msgCertificate = "No File Selected";
        return;
      }
    }

    const formdata: FormData = new FormData();
    
    if (this.logoImage) {
      this.myFiles.push(this.logoImage);
    }

    if (this.imgMemorandum) {
      this.myFilesimgMemorandum.push(this.logoMemorandum);
    }


    if (this.imgCertificate) {
      this.myFilesimgCertificate.push(this.logoCertificate);
    }

    // var cardNo = this.f.First6Number.value + 'XXXXXX' + this.f.Last6Number.value;
    // 111111XXXXXX2222 
    for (var i = 0; i < this.myFiles.length; i++) {
      this.KycType = 8;
      formdata.append("Image", this.myFiles[i]);
      formdata.append("ImageType", "MERCHANTLOGO");
      formdata.append("KycType", this.KycType);

    }
    for (var i = 0; i < this.addrsDocImageDataList.length; i++) {
      this.KycType = 9;
      formdata.append("KycType", this.KycType);
      if (i == 0) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS1");
      }
      else if (i == 1) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS2");
      }
      else if (i == 2) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS3");
      }
      else if (i == 3) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS4");
      }
      else if (i == 4) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS5");
      }
      else if (i == 5) {
        formdata.append("Image", this.addrsDocImageDataList[i]);
        formdata.append("ImageType", "ADDRESSPROOFDOCUMENTS6");
      }


    }
    for (var i = 0; i < this.shareholdersIDImageDataList.length; i++) {
      this.KycType = 10;
      formdata.append("KycType", this.KycType);

      if (i == 0) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS1");
      }
      else if (i == 1) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS2");
      }
      else if (i == 2) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS3");
      }
      else if (i == 3) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS4");
      }
      else if (i == 4) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS5");
      }
      else if (i == 5) {
        formdata.append("Image", this.shareholdersIDImageDataList[i]);
        formdata.append("ImageType", "IDCOPIESOFDIRECTORS6");
      }

    }
    for (var i = 0; i < this.shareholdersPicturesDataList.length; i++) {

      this.KycType = 11;
      formdata.append("KycType", this.KycType);
      if (i == 0) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS1");
      }
      else if (i == 1) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS2");
      }
      else if (i == 2) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS3");
      }
      else if (i == 3) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS4");
      }
      else if (i == 4) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS5");
      }
      else if (i == 5) {
        formdata.append("Image", this.shareholdersPicturesDataList[i]);
        formdata.append("ImageType", "PICTURESOFSHAREHOLDERS6");
      }
    }

    for (var i = 0; i < this.myFilesimgMemorandum.length; i++) {
      
      this.KycType = 31;
      formdata.append("Image", this.myFilesimgMemorandum[i]);
      formdata.append("ImageType", "MEMORANDUMARTICLESOFASSOCIATION");
      formdata.append("KycType", this.KycType);

    }
    for (var i = 0; i < this.myFilesimgCertificate.length; i++) {
      
      this.KycType = 32;
      formdata.append("Image", this.myFilesimgCertificate[i]);
      formdata.append("ImageType", "CERTIFICATEOFINCORPORATION");
      formdata.append("KycType", this.KycType);

    }
 
    formdata.append("Username", this.currentUser.email);
    this.loadingspinner = true;
    // 
    this.authService.merchantuploadFile(formdata).subscribe(response => {
      this.loadingspinner = false;
      this.dialogRef.close();
      this.logoImage = '';
      this.logoMemorandum = '';
      this.logoCertificate = '';

      this.imgURLlogo = '';
      this.imgURLaddrsFile = '';
      this.imgURLshareholdersID = '';
      this.imgURLshareholdersPicture = '';
      this.imgMemorandum = '';
      this.imgCertificate = '';


      this.addrsDocList = [];
      this.addrsDocImageDataList = [];

      this.shareholdersIDList = [];
      this.shareholdersIDImageDataList = [];

      this.shareholdersPicturesList = [];
      this.shareholdersPicturesDataList = [];

      if (response.apiStatus == true) {
        this.toastr.success(response.apiMessage, 'Success');
        this.withouttokenService.updateMessagewithouttoken(this.currentUser);
        this.dialogRef.close(true);

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service1.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      this.loadingspinner = false;
      this.dialogRef.close();
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getKYCUserDetails() {

    var Username = this.currentUser.email;
    this.loadingspinner = true;
    this.authService.KYCUserDetails(Username).subscribe(response => {
      this.loadingspinner = false;
      

      this.logoImage = '';
      this.logoMemorandum = '';
      this.logoCertificate = '';


      this.imgURLlogo = '';
      this.imgURLaddrsFile = '';
      this.imgURLshareholdersID = '';
      this.imgURLshareholdersPicture = '';
      this.imgMemorandum = '';
      this.imgCertificate = '';

      this.addrsDocList = [];
      this.addrsDocImageDataList = [];

      this.shareholdersIDList = [];
      this.shareholdersIDImageDataList = [];

      this.shareholdersPicturesList = [];
      this.shareholdersPicturesDataList = [];

      if (response.apiStatus == true) {

        if (response.apiData.length === 0) {
          this.imgURLlogo = '../../../../../assets/Images/imgId.png';

        }
        else {
          for (var i = 0; i < response.apiData.length; i++) {

            if (response.apiData[i].kycTypeId == 8) {
              this.imgURLlogo = response.apiData[i].doc_Path;
            }

            if (response.apiData[i].kycTypeId == 9) { //kycid
              this.addrsDocList.push(response.apiData[i].doc_Path);
            }

            if (response.apiData[i].kycTypeId == 10) {
              this.shareholdersIDList.push(response.apiData[i].doc_Path);
            }

            if (response.apiData[i].kycTypeId == 11) {
              this.shareholdersPicturesList.push(response.apiData[i].doc_Path);
            }

            if (response.apiData[i].kycTypeId == 31) {
              
              this.imgMemorandumurl = response.apiData[i].doc_Path;
              

            }
            if (response.apiData[i].kycTypeId == 32) {
              
              this.imgCertificateurl=response.apiData[i].doc_Path;
            }

          }

        }
      }
      else {
        this.toastr.error(response.error + response.apiMessage, 'Error');
      }
    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }



  previewpdf(files: any, type: any) {

    console.log(files);
    if (type === 5 && files.length === 0 || type === 6 && files.length === 0) {
      this.toastr.error('No file', 'Error');
      return;
    }

    if (files[0].size > 50000000) {
      this.toastr.error('maximum file size of 50 MB', 'Error');
      return;
    }
    

    

    if (files[0].type === 'application/pdf') {

      
      if (type === 5) {
        
        this.logoMemorandum=files[0];
        ////////console.log(files[0]);
        this.imgMemorandum = '';
      }
      else if (type === 6) {
        this.logoCertificate=files[0];
        ////////console.log(files[0]);
        this.imgCertificate = '';
      }


      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onloadend = (e) => {
      
        if (type === 5) {

          this.imgMemorandum = reader.result;
          this.imgMemorandumname = files[0].name;


          
        }
        else if (type === 6) {
          
          this.imgCertificate = reader.result;
          this.imgCertificatename = files[0].name;


        }


      };


    
    }
    else {
      this.toastr.error('Only PDF supported.', 'Error');
      return;
    }

  }


  preview(files: any, type: any) {


    if (type === 1 && files.length === 0) {
      this.toastr.error('No file', 'Error');
      return;
    }

    if (files[0].size > 50000000) {
      this.toastr.error('maximum file size of 50 MB', 'Error');
      return;
    }
    if (type === 2 && files.length === 6 || type === 3 && files.length === 6 || type === 4 && files.length === 6) {
      this.toastr.error('maximum file select exceed', 'Error');
      return;
    }

    const URL = window.URL || window.webkitURL;
    const Img = new Image();

    Img.src = URL.createObjectURL(files[0]);
    

    if (files[0].type === 'image/jpeg' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {

      if (type === 1) {
        this.logoImage = files[0];
        ////////console.log(files[0]);
        this.imgURLlogo = '';
      }
      else if (type === 2) {
        this.addrsDocImageDataList.push(files[0]);
        ////////console.log(files[0]);
        this.imgURLaddrsFile = '';
      }
      else if (type === 3) {
        this.shareholdersIDImageDataList.push(files[0]);
        ////////console.log(files[0]);
        this.imgURLshareholdersID = '';
      }
      else if (type === 4) {
        this.shareholdersPicturesDataList.push(files[0]);
        ////////console.log(files[0]);
        this.imgURLshareholdersPicture = '';
      }
      
      var reader = new FileReader();


      reader.readAsDataURL(files[0]);
      reader.onload = (e: any) => {
        


        Img.onload = (e: any) => {
          if (type === 1) {
            this.imgURLlogo = reader.result;
          }

          else if (type === 2) {
            this.addrsDocList.push(reader.result);
            this.imgURLaddrsFile = "not null";
          }
          else if (type === 3) {
            this.shareholdersIDList.push(reader.result);
            this.imgURLshareholdersID = "not null";
          }
          else if (type === 4) {
            this.shareholdersPicturesList.push(reader.result);
            this.imgURLshareholdersPicture = "not null";
          }

        }
      }
    }
    else {
      this.toastr.error('Only JPEG,PNG,JPG are supported.', 'Error');
      return;
    }

  }


  closeModal1(d: any) {
    
    this.addrsDocList.splice(d, 1);
    this.addrsDocImageDataList.splice(d, 1);
  }
  closeModal2(d: any) {
    
    this.shareholdersIDList.splice(d, 1);
    this.shareholdersIDImageDataList.splice(d, 1);
  }
  closeModal3(d: any) {
    
    this.shareholdersPicturesList.splice(d, 1);
    this.shareholdersPicturesDataList.splice(d, 1);
  }

  



}
